import LegalLayout from "@/components/LegalLayout";
import { COMPANY } from "@/lib/content";

export default function CookiesPage() {
  const sections = [
    {
      heading: "Our approach to cookies",
      paragraphs: [
        "This website is designed to work without non-essential cookies. We do not use advertising, retargeting or social-media tracking cookies, and we do not build advertising profiles from your visit.",
      ],
    },
    {
      heading: "Strictly necessary technologies we use",
      paragraphs: ["We use only the following, and only where genuinely necessary:"],
      list: [
        "A single secure, httpOnly session cookie that is set only when an authorised administrator signs in to the private Site Settings area. It keeps that administrator signed in and is not set for ordinary visitors and is not used for tracking.",
        "Our hosting and security provider may set a strictly necessary cookie to help protect the website against automated abuse.",
        "We do not use browser local storage or session storage to track visitors.",
      ],
    },
    {
      heading: "Analytics",
      paragraphs: [
        "We do not currently use any website analytics. Amanah does not use analytics tools, advertising pixels or non-essential tracking cookies in this release. We will review this position and update this notice before introducing any analytics.",
      ],
    },
    {
      heading: "Do you need to accept cookies?",
      paragraphs: [
        "Because we use only strictly necessary technologies, no cookie-consent banner is required to browse this website. You can still control or delete cookies at any time through your browser settings.",
      ],
    },
    {
      heading: "Questions",
      paragraphs: [`If you have any questions about cookies or privacy, please contact ${COMPANY.email}.`],
    },
  ];

  return (
    <LegalLayout
      eyebrow="Legal"
      title="Cookie Information"
      intro="How this website uses strictly necessary technologies only, with no analytics or tracking cookies."
      updated="8 August 2026"
      sections={sections}
    />
  );
}
